import { useEffect, useState } from "react";
import { Box, Grid, Stack, Typography, Icon, Link } from "@mui/material";
import { CreateOutlined, SearchOutlined } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

import useUserContext from "../../hooks/useUserContext";
import CardBoxExtended from "../../common/components/mui-extended/CardBoxExtended";
import AlertExtended from "../../common/components/mui-extended/AlertExtended";
import { PublicRoutesConfig, Register, RouteItem } from "../RoutesConfig";
import { dateToStringLong } from "../../common/utils/dateTime";
import authenticationService from "../../services/authenticationService";

export default function Home() {
  const [certificateNotAfter, setCertificateNotAfter] = useState<Date | null>();
  const { isExternalUser } = useUserContext();

  useEffect(() => {
    setCertificateNotAfter(authenticationService.getSignatureExpireDate(30));
  }, []);

  return (
    <Stack spacing={3}>
      <Typography variant="h5">Начало - бърз достъп</Typography>
      {certificateNotAfter && (
        <AlertExtended type="error">
          <Stack spacing={2}>
            <div>Срокът на валидност на електронния подпис изтича на {dateToStringLong(certificateNotAfter)}.</div>
            <div>
              Изпратете подновен публичен ключ на адрес:{" "}
              <Link href="mailto:support@notary-chamber.bg">support@notary-chamber.bg</Link>
            </div>
            <div>
              При нужда от съдействие се обърнете към екипа по поддръжка на тел: <strong>0700 10 116</strong>
            </div>
          </Stack>
        </AlertExtended>
      )}
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={isExternalUser ? 12 : 6}>
            <CardBoxExtended icon={<SearchOutlined />} title="Справки" titleColor="primary">
              <Stack spacing={3}>
                <HomeLink
                  register={PublicRoutesConfig.Authorization}
                  routeItem={PublicRoutesConfig.Authorization.Search}
                />
                <HomeLink
                  register={PublicRoutesConfig.WithdrawnAuthorization}
                  routeItem={PublicRoutesConfig.WithdrawnAuthorization.Search}
                />
                <HomeLink register={PublicRoutesConfig.Will} routeItem={PublicRoutesConfig.Will.Search} />
                <HomeLink
                  register={PublicRoutesConfig.TZCertifications}
                  routeItem={PublicRoutesConfig.TZCertifications.Search}
                />
                <HomeLink
                  register={PublicRoutesConfig.ZOZCertifications}
                  routeItem={PublicRoutesConfig.ZOZCertifications.Search}
                />
              </Stack>
            </CardBoxExtended>
          </Grid>
          {!isExternalUser && (
            <Grid item xs={12} lg={6}>
              <CardBoxExtended icon={<CreateOutlined />} title="Въвеждане" titleColor="primary">
                <Stack spacing={3}>
                  <HomeLink
                    register={PublicRoutesConfig.Authorization}
                    routeItem={PublicRoutesConfig.Authorization.New}
                  />
                  <HomeLink
                    register={PublicRoutesConfig.WithdrawnAuthorization}
                    routeItem={PublicRoutesConfig.WithdrawnAuthorization.New}
                  />
                  <HomeLink register={PublicRoutesConfig.Will} routeItem={PublicRoutesConfig.Will.New} />
                  <HomeLink
                    register={PublicRoutesConfig.TZCertifications}
                    routeItem={PublicRoutesConfig.TZCertifications.New}
                  />
                  <HomeLink
                    register={PublicRoutesConfig.ZOZCertifications}
                    routeItem={PublicRoutesConfig.ZOZCertifications.New}
                  />
                </Stack>
              </CardBoxExtended>
            </Grid>
          )}
        </Grid>
      </Box>
    </Stack>
  );
}

type HomeLinkProps = {
  register: Register;
  routeItem: RouteItem;
};

function HomeLink({ register, routeItem }: HomeLinkProps) {
  const { hasPermissions } = useUserContext();

  const render = () => {
    return (
      <Stack direction="row" spacing={1}>
        <Icon component="svg" color="secondary">
          {register.Root.Icon}
        </Icon>
        <Link component={RouterLink} to={routeItem.Path}>
          {register.Root.Label}
        </Link>
      </Stack>
    );
  };

  return hasPermissions(register, routeItem.Permission) ? render() : null;
}
